import { Link } from "react-router-dom";

const KINESERVE_LIGHT_LOGO = "https://customer-assets.emergentagent.com/job_kineserve-app/artifacts/yw1gx20r_KineServe_Logo_Light.svg";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { label: "Features", href: "#features" },
      { label: "Platform", href: "#platform" },
      { label: "Integrations", href: "#platform" },
      { label: "Pricing", href: "#contact" },
    ],
    company: [
      { label: "About", href: "https://greybulltechnologies.com/about-us/", external: true },
      { label: "Contact", href: "#contact" },
      { label: "Careers", href: "https://greybulltechnologies.com/careers/", external: true },
    ],
    resources: [
      { label: "Documentation", href: "#" },
      { label: "API Reference", href: "#" },
      { label: "System Status", href: "#" },
    ],
  };

  const scrollToSection = (e, href) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <footer className="footer" data-testid="footer">
      <div className="container-main">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 pb-12 border-b border-slate-700/50">
          {/* Brand Column */}
          <div className="col-span-2">
            <img 
              src={KINESERVE_LIGHT_LOGO} 
              alt="KineServe" 
              className="h-10 mb-4"
            />
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs mb-6">
              Next-generation IT Service Management platform. AI-powered, ITIL-aligned, 
              built for modern enterprises.
            </p>
            <div className="text-sm text-slate-500">
              A product of{" "}
              <a 
                href="https://greybulltechnologies.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white hover:text-blue-400 transition-colors"
              >
                Grey Bull Technologies
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Product</h4>
            <ul className="space-y-3">
              {footerLinks.product.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  {link.external ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <a
                      href={link.href}
                      onClick={(e) => scrollToSection(e, link.href)}
                      className="text-sm"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Resources</h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-sm">
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <Link to="/admin" className="text-sm">
                  Admin Panel
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-sm text-slate-500">
            &copy; {currentYear} KineServe. A Grey Bull Technologies LLP product. All rights reserved.
          </div>
          <div className="flex items-center gap-6 text-sm">
            <a href="#" className="text-slate-500 hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-slate-500 hover:text-white transition-colors">
              Terms of Service
            </a>
            <a href="#" className="text-slate-500 hover:text-white transition-colors">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
